import GetInitialMembershipRequestRequestModelBase from '../_generated/modelBases/get-initial-membership-request-request-model-base';

export default class GetInitialMembershipRequestRequestModel extends GetInitialMembershipRequestRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
